import { Injectable } from '@angular/core';
import { CRUDService } from 'src/app/core';
import { EClass } from 'src/app/model';
import { Subject, Observable } from 'rxjs';
import { IRequestEvent, EActionEvent } from 'src/app/users/src/users.model';

@Injectable()
export class TrainingService extends CRUDService {
	class = EClass.TRAINING;
	trainingSubjectEvent: Subject<IRequestEvent> = new Subject();
	trainingEvent: Observable<IRequestEvent> = this.trainingSubjectEvent.asObservable()


	private _trainingNext(obj: IRequestEvent) {
		this.trainingSubjectEvent.next(obj);
	}
	getTrainingEvent(): Observable<IRequestEvent> {
		return this.trainingEvent
	}

	createTraining(datas) {
		let training = {
			"exercice_id": parseInt(datas.exerciceCtrl),
			"user_id": parseInt(datas.user_id),
			"weight": datas.weightCtrl,
			"reps": datas.repsCtrl,
			"date": new Date()
		}
		this.create('data', { c: this.class }, training).subscribe(
			data => this._trainingNext({
				class: this.class,
				action: EActionEvent.CREATE,
				data: data
			})
		)
	}
	updateTraining(datas) {
		let training = {
			"exercice_id": parseInt(datas.exerciceCtrl),
			"user_id": parseInt(datas.user_id),
			"weight": datas.weightCtrl,
			"reps": datas.repsCtrl,
			"date": new Date()
		}
		this.update('data', datas.id, training, this.class).subscribe(
			data => this._trainingNext({
				class: this.class,
				action: EActionEvent.UPDATE,
				data: data
			})
		)
	}
	deleteTraining(trainingId) {
		this.delete('data', trainingId, this.class).subscribe(
			data => this._trainingNext({
				class: this.class,
				action: EActionEvent.DELETE,
				data: data
			})
		)
	}
}
